import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NativeAppleRemindersList, NativeAppleReminder } from '@demind-inc/core';
import { AppleRemindersSyncReq, tasksApi } from '../api';

interface UseSyncAppleRemindersParams {
  userId: string;
  metricId?: string;
  userPersona?: string;
  lists: NativeAppleRemindersList[];
  reminders: NativeAppleReminder[];
  deletedReminderIds?: string[];
}

export function useSyncAppleReminders() {
  const queryClient = useQueryClient();

  const syncAppleRemindersMutation = useMutation({
    mutationFn: async ({
      userId,
      metricId,
      userPersona,
      lists,
      reminders,
      deletedReminderIds,
    }: UseSyncAppleRemindersParams) => {
      const requestBody: AppleRemindersSyncReq = {
        userId,
        metricId: metricId || '',
        userPersona: userPersona || '',
        lists,
        reminders,
        deletedReminderIds,
      };

      const { data } = await tasksApi.syncAppleReminders(requestBody);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.tasks'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.overdueTasks'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.projects'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todoIntegrations'] });
    },
  });

  return {
    syncAppleReminders: syncAppleRemindersMutation.mutateAsync,
    isPending: syncAppleRemindersMutation.isPending,
    ...syncAppleRemindersMutation,
  };
}
